import { Routes, Route, Navigate } from 'react-router-dom'
import Home from '../pages/Home'
import Login from '../pages/Login'
import CustomerDisplay from '../pages/CustomerDisplay'
import ProtectedRoute from '../components/ProtectedRoute'
import Container from '../components/Container'

function AppRoutes() {
  return (
    <Routes>
      {/* Login */}
      <Route path="/login" element={<Login />} />

      {/* Staff POS - Protected routes */}
      <Route
        path="/staff"
        element={
          <ProtectedRoute>
            <Container>
              <Home />
            </Container>
          </ProtectedRoute>
        }
      />

      {/* Customer Display - No auth required, view-only */}
      <Route path="/customer" element={<CustomerDisplay />} />

      {/* Default redirect to staff */}
      <Route path="/" element={<Navigate to="/staff" replace />} />

      {/* Legacy route compatibility */}
      <Route
        path="/exchange"
        element={<Navigate to="/staff" replace />}
      />
    </Routes>
  )
}

export default AppRoutes
